import React from "react";
import "@progress/kendo-theme-default/dist/all.css";
import { sanitizeHTML } from "../../../../shared/validators/validator";
import "./AdvTextRenderer.scss";

const AdvTextRenderer = ({ element }) => {
  const { properties = {} } = element;
  const { value = "", fontSize = "14px", bold = false, italic = false, underline = false, textAlign = "left" } = properties;
  // Don't render if there's no text value
  if (!value || value.trim() === "") {
    return null;
  }
  // Better detection for HTML content - check for any HTML tags
  const editorView = /<[^>]+>/.test(value);
  const textStyles = {
    fontSize: ` ${fontSize}px`,
    fontWeight: bold ? "bold" : "normal",
    fontStyle: italic ? "italic" : "normal",
    textDecoration: underline ? "underline" : "none",
    textAlign,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    maxWidth: "100%",
    overflow: "hidden",
  };

  return (
    <div className='text-label-renderer mb-2'>
      {editorView ? (
        <div className='adv-text-renderer' style={textStyles} dangerouslySetInnerHTML={{ __html: sanitizeHTML(value) }} />
      ) : (
        <span className='text-label-content d-block' style={textStyles}>
          {value}
        </span>
      )}
    </div>
  );
};

export default AdvTextRenderer;
